<template lang="">
  <div>
    <template>
      <v-card :loading="loading" class="mx-auto my-12" max-width="374">
        <template slot="progress">
          <v-progress-linear
            color="blue"
            height="5"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title class="text-center">Opinión Técnica</v-card-title>
        <v-divider class="mx-4"></v-divider>

        <v-card-title>Ingresar código de acceso</v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="12" sm="12" class="pt-4 pb-0">
              <v-text-field
                :disabled="loading"
                autocomplete="off"
                class="required"
                dense
                filled
                color="blue-grey darken-2"
                v-model="codigo"
                label="Código"
                :rules="[required('Código'), maxLengthForm15('Código')]"
                maxlength="8"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn color="blue lighten-2" dark block @click="verificar">
            Ver Expediente
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </div>
</template>
<script>
import validations from "@/core/untils/validations.js";
import { VERIFICAR_CODIGO_OT } from "@/core/services/store/opinionesTecnicas/verificarcodigo.module";
import Swal from "sweetalert2";
export default {
  data: () => ({
    loading: false,
    selection: 1,
    ...validations,
    codigo: "",
  }),

  methods: {
    reserve() {
      this.loading = true;

      setTimeout(() => (this.loading = false), 2000);
    },
    async verificar() {
      this.loading = true;
      if (this.codigo === "") {
        Swal.fire({
          title: "",
          text: "Debe Ingresar el código de acceso.",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        this.loading = false;
        return;
      }
      await this.$store
        .dispatch(VERIFICAR_CODIGO_OT, { Codigo: this.codigo })
        .then((res) => {
          if (res.status === 200) {
            //console.log(res);
            this.$router.push({
              name: "vexpedienteot",
              params: {
                ExpedienteId: res.data.expedienteId,
                OTId: res.data.otId,
              },
            });
          } else {
            Swal.fire({
              title: "",
              text: res.message,
              icon: "error",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
          }
          this.loading = false;
          //this.dialogLoaderVisible = false;
          //this.btnRegistroLoading=false;
        })
        .catch((error) => {
          this.$refs.snackalert("warning", "Alerta", error);
          this.loading = false;
        });
    },
  },
};
</script>
<style lang=""></style>
